const log = (error: unknown) => {
  console.error(error);
};

export const ErrorLogger = { log };
